<script>
import TwNavigation from './components/TwNavigation';
import TwMainToolbar from './components/TwMainToolbar';
import TwContentWrapper from './components/TwContentWrapper';

export default {
  name: 'App',
  components: {
    TwNavigation,
    TwMainToolbar,
    TwContentWrapper,
  },
  mounted() {
    this.$Progress.finish();
  },
  created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  },
};
</script>

<template>
  <div id="app">
    <v-app>
      <v-responsive id="app-wrapper" min-width="1280px">
        <tw-navigation/>
        <tw-main-toolbar/>
        <tw-content-wrapper>
          <router-view/>
        </tw-content-wrapper>
      </v-responsive>
    </v-app>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<style lang="scss">
  .v-toolbar__content {
    min-width: 1280px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue